export const ANALYTICS_ANONYMOUS_ID = 'ANALYTICS_ANONYMOUS_ID';
export const ANALYTICS_SESSION_ID = 'analytics_session_id';
export const ASTRA_BUSINESS_INFORMATION_DIALOG_OPEN = 'astraBusinessInformationDialogOpen';
